// extracted by mini-css-extract-plugin
module.exports = {"no-boder-bottom":"react-calendar-custom_no-boder-bottom__4_JFA"};